/**
 *
 * FlexSwitcher
 *
 */

import React, { useRef } from 'react';
import styles from './multiswitch.module.css';

import { Icon } from 'semantic-ui-react';

function FlexSwitcher(props) {
  const {
    options,
    value,
    toggle,
    onChange,
    fillWidth,
    fillHeight,
    style,
    animate,
    nowrap,
    hollow = true,
    size,
    tabular,
    gutter = 10,
    rightGutter,
    bottomGutter,
    leftGutter,
    topGutter,
    guttered,
    multiple,
  } = props;

  const switchRef = useRef(null);
  let optionElems;
  if (options) {
    let optionElemStyle = {};
    if (animate === false) {
      optionElemStyle.animation = 'none';
    }
    if (toggle && options.length === 2) {
      let isOn = options[1].value === value;
      let selectedOption = options.find((option) => option.value === value);
      let alternateOption = options.find((option) => option.value !== value);
      if (!selectedOption || !alternateOption) {
        selectedOption = options[1];
        alternateOption = options[0];
      }

      let toggleTextContainerStyle = {};
      optionElemStyle.paddingRight = '35px';
      optionElemStyle.borderRadius = '30px';
      if (isOn) {
        toggleTextContainerStyle.transform = 'translate3d(0px, 0px, 0px)';
      } else {
        toggleTextContainerStyle.transform = 'translate3d(25px, 0px, 0px)';
      }

      if (animate === false) {
        optionElemStyle.animation = 'none';
      }

      if (size) {
        if (size === 'small') {
          optionElemStyle.minHeight = '20px';
          optionElemStyle.paddingRight = 20;
          if (isOn) {
            toggleTextContainerStyle.transform = 'translate3d(0px, 0px, 0px)';
          } else {
            toggleTextContainerStyle.transform = 'translate3d(15px, 0px, 0px)';
          }
        }
      }

      optionElems = [
        <div
          style={optionElemStyle}
          key={'selected_option'}
          className={`${styles.optionElem} ${styles.toggle} ${isOn ? styles.selected : ''}`}
          onClick={onChange.bind(null, alternateOption.value)}
        >
          <div style={toggleTextContainerStyle} className={styles.toggleTextContainer}>
            {selectedOption.icon && (
              <div style={{ marginRight: 10 }} className={`${styles.optionElemIcon} material-icons`}>
                {selectedOption.icon}
              </div>
            )}
            <div className={styles.optionElemLabel}>{selectedOption.text}</div>
          </div>
        </div>,
      ];
    } else {
      if (size === 'small') {
        optionElemStyle.minHeight = '20px';
        optionElemStyle.padding = '3px 7px';
        optionElemStyle.minWidth = '60px';
      }

      function handleChange(optionValue) {
        if (onChange && multiple) {
          let val = [];
          if (value && value.indexOf) {
            val = [...value];
          }
          if (val.indexOf(optionValue) > -1) {
            val.splice(val.indexOf(optionValue), 1);
          } else {
            val.push(optionValue);
          }
          onChange(val);
        } else if (onChange) {
          onChange(optionValue);
        }
      }

      optionElems = options.map((option) => {
        if (option.visible === false) {
          return null;
        }
        let elemStyle = { ...optionElemStyle };
        let isSelected =
          option.value === value || (multiple && value && value.indexOf && value.indexOf(option.value) > -1);
        if (isSelected && props.color) {
          elemStyle.background = props.color;
        } else if (isSelected) {
          elemStyle.background = 'var(--switcher-fill-activated)';
          elemStyle.color = 'var(--switcher-text-activated)';
        }

        if (option.style) {
          elemStyle = { ...elemStyle, ...option.style };
        }

        if (!fillWidth) {
          elemStyle.flex = 'auto';
          elemStyle.padding = '0px 15px';
        }

        if (!option.key) {
          // If this debugger has hit,
          // then It's whomever's responsibility to see this to fix the missing key rendering issue.
          debugger;
        }
        return (
          <div
            style={elemStyle}
            key={option.key || option.value}
            className={`${styles.optionElem} ${tabular ? styles.tabular : ''} ${isSelected ? styles.selected : ''}`}
            onClick={handleChange.bind(null, option.value)}
          >
            {option.icon && (
              <div style={{ paddingRight: 10 }} className={`${styles.optionElemIcon} material-icons`}>
                {option.icon}
              </div>
            )}
            {option.badge && <div className={styles.optionElemBadge}>{option.badge}</div>}
            <div className={styles.optionElemLabel}>{option.text}</div>
          </div>
        );
      });
    }
  }

  let switchStyle = style ? { ...style } : {};

  if (rightGutter || guttered) {
    switchStyle.marginRight = `${gutter}px`;
  }

  if (bottomGutter || guttered) {
    switchStyle.marginBottom = `${gutter}px`;
  }

  if (leftGutter || guttered) {
    switchStyle.marginLeft = `${gutter}px`;
  }

  if (topGutter || guttered) {
    switchStyle.marginTop = `${gutter}px`;
  }

  if (fillWidth) {
    switchStyle.width = '100%';
  }

  if (fillHeight) {
    switchStyle.height = 'auto';
  }

  if (nowrap) {
    switchStyle.whiteSpace = 'nowrap';
  }

  if (hollow) {
    switchStyle.background = 'var(--switcher-fill-enabled)';
    switchStyle.boxShadow = 'none';
    switchStyle.border = '1px solid var(--switcher-border-enabled)';
  }

  if (toggle) {
    let isOn = options[1].value === value;
    let toggleStyle = {};

    if (isOn && switchRef.current) {
      toggleStyle.transform = `translate3d(${switchRef.current.getBoundingClientRect().width - 31}px, 0px, 0px)`;
    } else {
      toggleStyle.transform = `translate3d(5px, 0px, 0px)`;
      switchStyle.background = 'var(--switcher-fill-enabled)';
      switchStyle.border = '1px solid transparent';
    }

    switchStyle.borderRadius = '30px';

    switchStyle.alignItems = 'center';
    if (size) {
      if (size === 'small') {
        switchStyle.minHeight = 24;
        switchStyle.fontSize = '10px';
        switchStyle.lineHeight = '10px';
        toggleStyle.width = 16;
        toggleStyle.height = 16;
        if (isOn && switchRef.current) {
          toggleStyle.transform = `translate3d(${switchRef.current.getBoundingClientRect().width - 22}px, 0px, 0px)`;
        } else {
          toggleStyle.transform = `translate3d(5px, 0px, 0px)`;
        }
      }
    }

    return (
      <div ref={switchRef} style={switchStyle} className={styles.multiswitch}>
        <div style={toggleStyle} className={styles.toggleElement}></div>
        {optionElems}
      </div>
    );
  } else {
    if (size) {
      if (size === 'small') {
        switchStyle.minHeight = 28;
        switchStyle.fontSize = '10px';
        switchStyle.lineHeight = '10px';
      }
    }

    return (
      <div style={switchStyle} className={`${styles.multiswitch} ${tabular ? styles.tabular : ''}`}>
        {optionElems}
      </div>
    );
  }
}

FlexSwitcher.propTypes = {};

export default FlexSwitcher;
